import resume from '../assets/pdf/resume.pdf'

export const headerData = {
    name: 'Md Kaikubad',
    title: "Fullstack Developer",
    desciption:"As a dedicated software engineer with a wealth of expertise in web development and a fervent passion for continual growth, I eagerly embrace opportunities to expand my knowledge and skills.",
    image: 'https://res.cloudinary.com/dolfbkb8h/image/upload/v1705906877/kaikubad.com/me-prisma_xgwmiq.jpg',
    resumePdf: resume
}
